import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  clientInfo: { phoneNumber?: string }
}

type Actions = {
  setClientInfo: ({ phoneNumber }: { phoneNumber: string }) => void
  resetClientInfo: () => void
}

const devtoolsInProd = process.env.NODE_ENV === 'production'

const useClientInfoStore = create(
  devtools(
    immer<State & { actions: Actions }>((set) => ({
      clientInfo: {},
      actions: {
        setClientInfo: ({ phoneNumber }) => {
          return set((state) => {
            state.clientInfo = { phoneNumber }
          })
        },
        resetClientInfo: () => {
          return {}
        },
      },
    })),
    { enabled: !devtoolsInProd }
  )
)

const useClientInfo = () => useClientInfoStore((s) => s.clientInfo)
const useClientInfoActions = () => useClientInfoStore((s) => s.actions)

export { useClientInfo, useClientInfoActions }
